/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import PDialog from "../../components/pos/PDialog";
import React, { useState } from "react";
import API from "../../utils/API";

export default function PFileUploader(props) {
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowtitle] = useState("File Upload");
  const [fileUploadPath, setFileUploadPath] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  props.biRef.fileUpload = {
    showPFileUploader: showPFileUploader,
  };

  function showPFileUploader(windowTitle, fileUploadPath) {
    setOpenWindow(true);
    setWindowtitle(windowTitle);
    setFileUploadPath(fileUploadPath);
  }
  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onChangeHandler(event) {
    setSelectedFile(event.target.files[0]);
  }

  function handleUploadFile() {
    if (
      selectedFile != null &&
      selectedFile != "" &&
      fileUploadPath != null &&
      fileUploadPath != ""
    ) {
      const data = new FormData();
      data.append("file", selectedFile);
      API.post(fileUploadPath, data, {}).then((res) => {
        if (props.onFileSelected) props.onFileSelected(res.data);
        setOpenWindow(false);
      });
    }
  }

  const content = (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12}>
        <table width="100%">
          <tr>
            <td>
              {" "}
              <input
                type="file"
                name="file"
                onChange={(e) => onChangeHandler(e)}
              />
            </td>
            <td>
              <Button onClick={handleUploadFile} color="primary">
                Upload
              </Button>
            </td>
          </tr>
        </table>
      </Grid>
    </Grid>
  );

  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
        ></PDialog>
      )}
    </div>
  );
}
